import React, { useState } from 'react';
import Header from './components/Header';
import HeroBanner from './components/HeroBanner';
import StatsBar from './components/StatsBar';
import ProgramCards from './components/ProgramCards';
import EmiScholarship from './components/EmiScholarship';
import HiringPartners from './components/HiringPartners';
import Testimonials from './components/Testimonials';
import EnquiryFormSection from './components/EnquiryFormSection';
import Footer from './components/Footer';
import BrochureModal from './components/BrochureModal';
import PaymentResultModal from './components/PaymentResultModal';
import SuccessPage from './pages/SuccessPage';
import FailPage from './pages/FailPage';
import { MessageSquare } from 'lucide-react';
import './App.css';

function App() {
  const [modalState, setModalState] = useState({
    isOpen: false,
    university: 'Manipal University Jaipur',
    mode: 'brochure' // 'brochure' or 'enquiry'
  });

  const path = window.location.pathname;
  const search = window.location.search;
  const params = new URLSearchParams(search);
  const paymentStatus = params.get('payment');

  const isSuccessPage = path === '/success' || path === '/payment-success' || paymentStatus === 'success';
  const isFailPage = path === '/failure' || path === '/fail' || path === '/payment-failure' || paymentStatus === 'failure';

  const navigateToHome = () => {
    window.location.href = '/';
  };

  const navigateToEnquiry = () => {
    window.location.href = '/#enquiry-section';
  };

  const handleOpenBrochure = (university = 'Manipal University Jaipur') => {
    setModalState({
      isOpen: true,
      university,
      mode: 'brochure'
    });
  };

  const handleOpenEnquiryModal = (university = 'Manipal University Jaipur') => {
    setModalState({
      isOpen: true,
      university,
      mode: 'enquiry'
    });
  };

  const handleCloseModal = () => {
    setModalState((prev) => ({ ...prev, isOpen: false }));
  };

  const scrollToEnquiry = () => {
    const section = document.getElementById('enquiry-section');
    if (section) {
      section.scrollIntoView({ behavior: 'smooth' });
    } else {
      handleOpenEnquiryModal();
    }
  };

  const scrollToPrograms = () => {
    const section = document.getElementById('programs');
    if (section) {
      section.scrollIntoView({ behavior: 'smooth' });
    }
  };

  // Dedicated Success Page View
  if (isSuccessPage) {
    return <SuccessPage onHomeClick={navigateToHome} />;
  }

  // Dedicated Failure Page View
  if (isFailPage) {
    return <FailPage onHomeClick={navigateToHome} onRetryClick={navigateToEnquiry} />;
  }

  // Main Online Manipal Landing Page
  return (
    <div className="landing-app">
      {/* Header Navigation */}
      <Header
        onOpenEnquiry={scrollToEnquiry}
        onOpenApply={scrollToPrograms}
      />

      {/* Main Hero Banner with Embedded Counselling Lead Form */}
      <main>
        <HeroBanner onOpenBrochure={() => handleOpenBrochure('Manipal University Jaipur')} />

        {/* Highlights & Statistics Bar */}
        <StatsBar />

        {/* Explore MBA Programs (MUJ, MAHE, SMU) */}
        <ProgramCards
          onOpenBrochure={handleOpenBrochure}
          onOpenEnquiry={handleOpenEnquiryModal}
        />

        {/* EMI & Scholarships Options */}
        <EmiScholarship onApply={scrollToPrograms} />

        {/* Reputed Hiring Partners */}
        <HiringPartners />

        {/* Learner Testimonials & Video Stories */}
        <Testimonials />

        {/* Dedicated Enquiry Form Section */}
        <EnquiryFormSection defaultUniversity="MUJ" />
      </main>

      {/* Simplified Footer with Copyright & 2 CTA Buttons */}
      <Footer
        onOpenEnquiry={scrollToEnquiry}
        onOpenApply={scrollToPrograms}
      />

      {/* Reusable Modal for Brochure Downloads & Quick Enquiry */}
      <BrochureModal
        isOpen={modalState.isOpen}
        onClose={handleCloseModal}
        selectedUniversity={modalState.university}
        mode={modalState.mode}
      />

      {/* PayU Payment Success / Failure Result Modal fallback */}
      <PaymentResultModal onRetry={scrollToEnquiry} />

      {/* Floating Quick Action Widget */}
      <div className="floating-action-widget">
        <button
          className="floating-enquire-btn"
          onClick={scrollToEnquiry}
          title="Quick Enquiry"
        >
          <MessageSquare size={18} />
          <span className="widget-text">Enquire Now</span>
        </button>
      </div>
    </div>
  );
}

export default App;
